module.exports = __webpack_public_path__ + "img/ornament-827.e4683d1e.png";